import { render, staticRenderFns } from "./SwifterWaitDurationSecondsForm.vue?vue&type=template&id=f1254b36&scoped=true"
import script from "./SwifterWaitDurationSecondsForm.vue?vue&type=script&lang=js"
export * from "./SwifterWaitDurationSecondsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1254b36",
  null
  
)

export default component.exports